<template>
  <div class="bg-beige-academy-100 rounded-3xl flex flex-col shadow-lg">
    <div class="flex flex-col items-center justify-center md:relative">
      <span class="text-base lg:text-xl uppercase py-3 md:py-6">{{ template.description }}</span>
      <div class="flex space-x-3 mb-2">
        <router-link class="hover:text-beige-academy-500 md:absolute right-4 top-2"
          :to="'/teacher-dashboard/templates/'+template.id">
          <edit-icon class="w-3 lg:w-4" />
        </router-link>
        <button class="hover:text-beige-academy-500 md:absolute right-2 top-2"
          @click="$emit('delete')">
          <bin-icon class="w-3 lg:w-4" />
        </button>
      </div>
    </div>

    <div class="h-44 bg-white mb-10 mx-6 lg:mx-16 shadow-lg rounded-lg flex flex-wrap
    overflow-y-scroll">
      <media-in-template-card v-for="media in template.media"
        :key="media.id" :media="media" class="m-5" />
    </div>
  </div>
</template>

<script>
import BinIcon from '../graphics/BinIcon.vue';
import EditIcon from '../graphics/EditIcon.vue';
import MediaInTemplateCard from './MediaInTemplateCard.vue';

export default {
  components: { EditIcon, MediaInTemplateCard, BinIcon },
  props: ['template'],
};
</script>
